export const GET_MERCHANT_PAYMENT_FILE_LIST = "GET_MERCHANT_PAYMENT_FILE_LIST"
export const GET_MERCHANT_PAYMENT_FILE_LIST_SUCCESS = "GET_MERCHANT_PAYMENT_FILE_LIST_SUCCESS"
export const GET_MERCHANT_PAYMENT_FILE_LIST_FAIL = "GET_MERCHANT_PAYMENT_FILE_LIST_FAIL"

export const GET_MERCHANT_PAYMENT_FILE_SEARCH = "GET_MERCHANT_PAYMENT_FILE_SEARCH"
export const GET_MERCHANT_PAYMENT_FILE_SEARCH_SUCCESS = "GET_MERCHANT_PAYMENT_FILE_SEARCH_SUCCESS"
export const GET_MERCHANT_PAYMENT_FILE_SEARCH_FAIL = "GET_MERCHANT_PAYMENT_FILE_SEARCH_FAIL"

export const GET_MERCHANT_PAYMENT_DETAIL_LIST = "GET_MERCHANT_PAYMENT_DETAIL_LIST"
export const GET_MERCHANT_PAYMENT_DETAIL_LIST_SUCCESS = "GET_MERCHANT_PAYMENT_DETAIL_LIST_SUCCESS"
export const GET_MERCHANT_PAYMENT_DETAIL_LIST_FAIL = "GET_MERCHANT_PAYMENT_DETAIL_LIST_FAIL"

export const MERCHANT_PAYMENT_FILE_API_ERROR = "MERCHANT_PAYMENT_FILE_API_ERROR"